"use client";

import { Search, LogOut, ChevronDown } from "lucide-react";
import { formatDate, getGreeting } from "@/lib/utils";
import { useAuth, useVertical } from "@/contexts";
import { Avatar, Button } from "@/components/ui";
import * as React from "react";

export function Header() {
  const { user, logout } = useAuth();
  const { config } = useVertical();
  const [showMenu, setShowMenu] = React.useState(false);
  const greeting = getGreeting();
  const today = formatDate(new Date());

  const displayName = user?.name?.split(" ")[0] || user?.email?.split("@")[0] || "Usuário";

  return (
    <header className="sticky top-0 z-30 flex h-20 items-center justify-between border-b border-gray-100 bg-background/80 px-8 backdrop-blur-sm">
      {/* Left - Greeting */}
      <div>
        <h2 className="font-outfit text-2xl font-light tracking-wide text-foreground">
          {greeting}, {displayName} <span className="inline-block animate-pulse">✨</span>
        </h2>
        <p className="mt-1 text-sm capitalize text-foreground-secondary">
          {today}
        </p>
      </div>

      {/* Right - Search & User */}
      <div className="flex items-center gap-4">
        {/* Search */}
        <div className="relative">
          <Search
            className="absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-foreground-secondary/50"
            strokeWidth={1.5}
          />
          <input
            type="text"
            placeholder={config.branding.searchPlaceholder}
            className="h-11 w-80 rounded-xl border border-gray-200 bg-white pl-11 pr-4 text-sm transition-all duration-200 placeholder:text-foreground-secondary/50 focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/20"
          />
        </div>

        {/* User Menu */}
        <div className="relative">
          <button
            onClick={() => setShowMenu(!showMenu)}
            className="flex items-center gap-2 rounded-xl p-2 transition-colors hover:bg-gray-100"
          >
            <Avatar name={user?.name || user?.email || ""} size="sm" />
            <ChevronDown className="h-4 w-4 text-foreground-secondary" />
          </button>

          {showMenu && (
            <>
              <div
                className="fixed inset-0 z-40"
                onClick={() => setShowMenu(false)}
              />
              <div className="absolute right-0 top-full z-50 mt-2 w-48 rounded-xl border border-gray-100 bg-white p-2 shadow-lg">
                <div className="border-b border-gray-100 px-3 py-2">
                  <p className="text-sm font-medium text-foreground">{user?.name || "Usuário"}</p>
                  <p className="text-xs text-foreground-secondary">{user?.email}</p>
                </div>
                <button
                  onClick={async () => {
                    setShowMenu(false);
                    await logout();
                  }}
                  className="mt-2 flex w-full items-center gap-2 rounded-lg px-3 py-2 text-sm text-status-error transition-colors hover:bg-status-error/10"
                >
                  <LogOut className="h-4 w-4" strokeWidth={1.5} />
                  Sair
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
